import { MessageSquareReply, EyeOff, Bot, TrendingUp } from "lucide-react";

export const ReplyDeliverabilityKeyFindings = () => {
  const findings = [
    {
      icon: EyeOff,
      stat: "50%+",
      title: "Open Rates Are Hidden or Fake",
      description: "Apple Mail Privacy Protection pre-loads tracking pixels for 50%+ of mobile users, making opens appear for emails never opened. Meanwhile, security bots click every link, inflating metrics further.",
      color: "text-destructive",
      bgColor: "bg-destructive/10",
    },
    {
      icon: MessageSquareReply,
      stat: "3x",
      title: "Replies Boost Sender Score",
      description: "ISPs now weight reply signals 3x higher than opens for sender reputation. A reply proves human engagement—something bots can't fake. This directly impacts inbox placement for future sends.",
      color: "text-primary",
      bgColor: "bg-primary/10",
    },
    {
      icon: Bot,
      stat: "30-40%",
      title: "Bot Opens Corrupt Your Data",
      description: "GetResponse research shows 30-40% of recorded opens come from security scanning tools, not humans. Building strategy on corrupted data leads to poor decisions and declining deliverability.",
      color: "text-chart-2",
      bgColor: "bg-chart-2/10",
    },
    {
      icon: TrendingUp,
      stat: "2026",
      title: "Gmail's Reply-First Algorithm",
      description: "Gmail's 2026 algorithm update explicitly prioritizes senders who generate replies. Their machine learning models now identify 'conversation starters' vs 'broadcast senders'—and filter accordingly.",
      color: "text-chart-4",
      bgColor: "bg-chart-4/10",
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        Why Replies Are the New Opens
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        The death of reliable open tracking has forced ISPs to find a new signal for sender quality. 
        Replies emerged as the answer—they can't be faked and prove genuine human engagement.
      </p>

      <div className="grid md:grid-cols-2 gap-6">
        {findings.map((finding, index) => (
          <div
            key={index}
            className="bg-card rounded-xl border border-border p-6 hover:border-primary/30 transition-colors"
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-xl ${finding.bgColor} flex items-center justify-center shrink-0`}>
                <finding.icon className={`w-6 h-6 ${finding.color}`} />
              </div>
              <div>
                <div className={`text-2xl font-bold ${finding.color} mb-1`}>{finding.stat}</div>
                <h3 className="font-semibold text-foreground mb-2">{finding.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{finding.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};